/* Stealth V3 shared card: Add to cart on single-variant parts (ruling D1). Loaded on every template (layout/theme.liquid).
   The card prints a real /cart/add form, so no-JS posts work. With JS the first submit binds Impulse's own
   theme.AjaxProduct to the form (its listener handles every later submit), so the add posts Impulse's FormData and
   fires ajaxProduct:added, which opens the cart drawer. States: busy "Adding...", done "Added" for 1.5 s.
   Selectors are scoped to form[data-sp-card-form] (nav-v3 lesson: never a bare attribute selector). */
(function () {
  'use strict';
  var TICK = '<svg class="sp-card__tick" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }
  function btnOf(form) { return form.querySelector('button.sp-card__atc'); }
  function label(btn) {
    if (!btn._spLabel) btn._spLabel = btn.innerHTML;
    return btn._spLabel;
  }
  function busy(form, on) {
    var b = btnOf(form);
    if (!b) return;
    label(b);
    if (on) {
      b.setAttribute('aria-busy', 'true');
      b.innerHTML = 'Adding...<span class="visually-hidden">' + (b.querySelector('.visually-hidden') || { textContent: '' }).textContent + '</span>';
    } else {
      b.removeAttribute('aria-busy');
      b.innerHTML = b._spLabel;
    }
  }
  function done(form) {
    var b = btnOf(form);
    if (!b) return;
    b.removeAttribute('aria-busy');
    b.classList.add('is-added');
    b.innerHTML = TICK + 'Added';
    clearTimeout(b._spT);
    b._spT = setTimeout(function () { b.classList.remove('is-added'); b.innerHTML = b._spLabel; }, 1500);
  }

  var pending = null;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-sp-card-form]')) return;
    var card = form.closest('.sp-card-item');
    publish('sp_cta', { style: 'primary', surface: 'card_' + ((card && card.getAttribute('data-surface')) || 'unknown'), handle: card && card.getAttribute('data-product-handle') });
    pending = form;
    busy(form, true);
    if (form._spAjax) return; /* Impulse's own listener on the form handles it */
    if (!(window.theme && theme.AjaxProduct)) { busy(form, false); return; } /* plain POST */
    form._spAjax = new theme.AjaxProduct(form, 'button.sp-card__atc');
    form._spAjax.addItemFromForm(e);
  });
  /* Success fires on the form (bubbles) with detail.product; a 422 fires on document with no detail. */
  document.addEventListener('ajaxProduct:added', function (e) {
    var form = e.target && e.target.matches && e.target.matches('form[data-sp-card-form]') ? e.target : null;
    if (form && e.detail && e.detail.product) { done(form); if (pending === form) pending = null; return; }
    if (!e.detail && pending) { busy(pending, false); pending = null; }
  });

  /* QA 2026-10-12 (Ricky, desktop rollover): sp-card.css hides the first photo on hover so the hover photo replaces it
     (both blend with multiply), but only on wells marked is-alt-ready, so a first hover while the hover photo is still
     arriving never shows an empty well. A sweep marks photos already loaded, then a capture-phase load listener (load
     does not bubble) marks the rest, including cards injected later (search results, recommendations). */
  function altReady(img) {
    var well = img.closest ? img.closest('.sp-card__well') : null;
    if (well) well.classList.add('is-alt-ready');
  }
  function altSweep() {
    Array.prototype.forEach.call(document.querySelectorAll('img.sp-card__img--alt'), function (img) {
      if (img.complete && img.naturalWidth > 0) altReady(img);
    });
  }
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('img.sp-card__img--alt')) altReady(t);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', altSweep); else altSweep();
})();
